import { RenderCallback, renderComponent } from 'utils/RenderingUtils';
import { IDependenciesBrowserProps } from './DependenciesBrowser';

export async function renderDependenciesBrowser(
  props: IDependenciesBrowserProps,
  container: HTMLElement,
  callback?: RenderCallback
) {
  const { DependenciesBrowser } = await import('./DependenciesBrowser');

  return renderComponent({
    container,
    component: <DependenciesBrowser {...props} />,
    callback,
    autoUnmount: false,
  });
}
